import PropTypes from 'prop-types'

export const locationDescriptionPropType = PropTypes.shape({
    address: PropTypes.string,
    params: PropTypes.object // eslint-disable-line react/forbid-prop-types
})
